import { FaultSearchDto, useSafetyDeviceSearchApi } from "~/api/GeneratedApi";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";
import { NullCheck } from "../tabs/SecurityDeviceSearchTab";

export type ActionSearchOptions = {
  options: NullCheck<FaultSearchDto> | undefined;
};

export const useFaultSearch = ({ options }: ActionSearchOptions) => {
  const { faultSearch } = useSafetyDeviceSearchApi();

  const {
    data: faults,
    isFetching,
    isLoading,
  } = useCustomQuery(
    { key: "fault-search", dto: options as FaultSearchDto },
    () => faultSearch(options as FaultSearchDto),
    { enabled: options !== undefined, staleTime: 1000 * 60 * 5 },
  );

  return { faults, isFetching, isLoading };
};
